<template>
  <div>
    <el-button style="margin-bottom: 20px" type="primary" @click="add(null)"
      >添加
    </el-button>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column
        align="center"
        label="名称"
        prop="name"
      ></el-table-column>
      <el-table-column
        align="center"
        label="创建时间"
        prop="createTime"
      ></el-table-column>
      <el-table-column align="center" fixed="right" label="操作" prop="icon">
        <template slot-scope="scope">
          <el-button plain type="primary" @click="add(scope.row)"
            >编辑</el-button
          >
          <el-button plain type="danger" @click="delHandle(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :before-close="handleClose"
      :title="editForm.id ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="140px"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>

        <el-form-item style="margin-top: 80px">
          <el-button type="primary" @click="submitForm('editForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "technologyClass",
  components: {},
  data() {
    return {
      editForm: {
        name: "",
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      goodsList: [],
    };
  },
  created() {
    this.getHomePopList();
  },
  methods: {
    change(val) {
      this.editForm.describe = val;
    },
    add(event) {
      if (event) {
        this.editForm = JSON.parse(JSON.stringify(event));
      } else {
        this.editForm = {
          name: "",
        };
      }
      this.dialogVisible = true;
    },
    handleClose() {
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
    },
    getHomePopList() {
      this.$axios.get("/admin/technologyClass/getList").then((res) => {
        this.tableData = res.data;
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {
            name: this.editForm.name,
          };
          if (this.editForm.id) {
            obj.id = this.editForm.id;
            this.$axios.post("/admin/technologyClass/upd", obj).then((res) => {
              this.handleClose();
              this.getHomePopList();
              this.$message({
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
          } else {
            this.$axios.post("/admin/technologyClass/add", obj).then((res) => {
              this.handleClose();
              this.getHomePopList();
              this.$message({
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
          }
        } else {
          return false;
        }
      });
    },

    delHandle(val) {
      var _this = this;
      this.$confirm("此操作将删除该技术分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/admin/technologyClass/del", {
              id: val,
            })
            .then((res) => {
              _this.getHomePopList();
              _this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
